import { computed, observable, runInAction, action } from 'mobx';
import { projects, Project } from './countryProjects';

export class CountryProjectsStore {
  @observable projects: projects = [];
  @observable state: string = 'init';

  Admin = null;

  @computed get archivedProjects(): projects {
    return this.projects.filter((project) => project.status === 'Archived');
  }
  @computed get activeProjects(): projects {
    return this.projects.filter((project) => project.status === 'Active');
  }

  @computed get hasProjects(): boolean {
    return this.projects.length > 0;
  }

  @action clearAllProjects() {
    this.projects.length = 0;
  }

  @action makeSyncERPprojects(clientID) {
    return this.Admin.makeSyncERPprojects(clientID);
  }

  @action addNewProject(project: Project) {
    this.projects.push(project);
  }

  @action cancelAddingNewProject(project: Project) {
    this.projects.splice(this.projects.indexOf(project), 1);
  }

  @action saveEditedProject(project: Project) {
    project.saving = true;
    const projectToSave = { ...project };
    if (projectToSave.noExpirationDate == true) {
      delete projectToSave.validUntil;
    }
    delete projectToSave.noExpirationDate;

    return this.Admin.editProjectForClient(projectToSave, project.id).then(
      (resp) => {
        runInAction(() => {
          const editedProject = resp.data;
          editedProject.noExpirationDate = !resp.data.validUntil;

          this.projects = this.projects.map((p) => {
            if (p.id == project.id) {
              return { ...editedProject, saving: false, edited: false };
            }
            else return p;
          });
        });
      },
      () => {
        runInAction(() => {
          this.projects = this.projects.map((p) => {
            if (p.id == project.id) {
              return { ...p, error: true, saving: false };
            }
            else return p;
          });
        });
      }
    );

  }

  @action saveNewProject(project: Project, selectedClientId) {
    project.saving = true;
    const projectToSend = { ...project };
    projectToSend.clientId = selectedClientId;
    if (projectToSend.noExpirationDate == true) {
      projectToSend.validUntil = null;
      delete projectToSend.noExpirationDate;
      delete projectToSend.validUntil;
    } else {
      delete projectToSend.noExpirationDate;
    }

    return this.Admin.addProjectForClient(projectToSend).then(
      (resp) => {
        runInAction(() => {
          this.projects.splice(this.projects.indexOf(project), 1);
          const addedProject = {
            ...resp.data,
            noExpirationDate: !resp.data.validUntil,
            saving: false,
            new: false,
          };
          this.projects.push(addedProject);
        });
      },
      () => {
        runInAction(() => {
          this.projects = this.projects.map((p) => {
            if (p.id == project.id) {
              return { ...p, saving: false, error: true };
            }
            else return p;
          });
        });
      }
    );
  }

  @action getProjects(clientID) {
    this.state = 'loading';
    this.projects = [];

    return this.Admin.getProjectsForClient(clientID).then(
      (resp) => {
        runInAction(() => {
          this.projects = resp.data.map((project) => {
            return {
              ...project,
              noExpirationDate: !project.validUntil,
            };
          });
          this.state = "loaded";
        });
      },
      () => {
        runInAction(() => {
          this.state = 'loaded';
        });
      }
    );
  }

  @action restoreProject(project: Project) {

    return this.Admin.activateProject(project.id).then(
      (resp) => {
        runInAction(() => {
          const activatedProject = resp.data;
          activatedProject.noExpirationDate = !resp.data.validUntil;
          this.projects = this.projects.map((p) => {
            if (p.id == project.id) {
              return { ...activatedProject, status: "Active", saving: false };
            }
            else return p;
          });
        });
      },
      () => {
        runInAction(() => {
          this.projects = this.projects.map((p) => {
            if (p.id == project.id) {
              return { ...p, saving: false, error: true };
            }
            else return p;
          });

          return project;
        });
      }
    );
  }

  @action archiveProject(project: Project) {

    return this.Admin.archiveProject(project.id).then(
      (resp) => {
        runInAction(() => {
          const archivedProject = resp.data;
          archivedProject.noExpirationDate = !resp.data.validUntil;

          this.projects = this.projects.map((p) => {
            if (p.id == project.id) {
              return { ...archivedProject, status: "Archived", saving: false };
            }
            else return p;
          });
        });
      },
      () => {
        runInAction(() => {
          this.projects = this.projects.map((p) => {
            if (p.id == project.id) {
              return { ...p, saving: false, error: true };
            }
            else return p;
          });
        });
      }
    );
  }
}
export const countryProjectsStore = new CountryProjectsStore;
